export default function SermonInfo() {
  return (
    <div style={{ padding: 16 }}>
      <h3>About Sermon Builder</h3>
      <p>This tool helps organize sermon structure, verses, and flow.</p>
    </div>
  );
}
